// extracted by mini-css-extract-plugin
module.exports = {"cta":"Index_cta__JBk7a","title":"Index_title__FUwyz","subtitle":"Index_subtitle__fpM7g","tag_col":"Index_tag_col__eID6V"};